
/**
 * 링크 유형 (외부 링크 또는 프로젝트 링크)
 */
export type ExploreContentItemContentOneOfMediaLinksItemLinkType = typeof ExploreContentItemContentOneOfMediaLinksItemLinkType[keyof typeof ExploreContentItemContentOneOfMediaLinksItemLinkType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExploreContentItemContentOneOfMediaLinksItemLinkType = {
  EXTERNAL: 'EXTERNAL',
  PROJECT: 'PROJECT',
} as const;
